import { IPluginMetadataSucceededResult } from 'app/apis/plugin-metadata-api.service';

import { format } from 'app/shared/utils/string.util';

const connector: IPluginMetadataSucceededResult = {
    connectorName: 'GoogleSheets',
    dataType: 'Hierarchical',
    SupportEncryption: true,
    connectionSettings: [
        {
            type: 'String',
            name: 'apiToken',
            required: true,
            sensitive: true,
            signature: false
        }
    ],
    readSettings: [
        {
            type: 'String',
            name: 'spreadSheetId',
            displayName: stringResources.Dataflow_GoogleSheets_spreadsheetId,
            required: true
        },
        {
            type: 'String',
            name: 'sheetName',
            displayName: stringResources.ModelName_SheetName,
            required: true
        },
        {
            type: 'String',
            name: 'startCell',
            displayName: stringResources.Dataflow_GoogleSheets_startCell,
            required: true
        },
        {
            type: 'String',
            name: 'endCell',
            displayName: stringResources.Dataflow_GoogleSheets_endCell,
            required: true
        }
    ],
    writeSettings: [],
    adfAppModelConfiguration: {
        displayName: format(stringResources.ModelName_DisplayTextPreviewTemplate, 'Google Sheets'),
        icon: {
            className: 'svg-i-100x100-GoogleSheets'
        },
        category: ['ServicesApps'],
        linkedService: {
            properties: [
                'apiToken'
            ],
            uiControls: [
                {
                    bind: 'apiToken',
                    controlType: 'TextBox',
                    displayName: stringResources.ModelName_Token
                }
            ]
        },
        dataflowInlineSource: {
            properties: [
                'spreadSheetId',
                'sheetName',
                'startCell',
                'endCell'
            ],
            uiControls: [
                {
                    bind: 'spreadSheetId',
                    controlType: 'TextBox',
                    displayName: stringResources.Dataflow_GoogleSheets_spreadsheetId,
                    required: true,
                    description: stringResources.DataFlow_GoogleSheets_spreadsheetId_Description
                },
                {
                    bind: {
                        schema: 'sheetName'
                    },
                    controlType: 'SchemaTableSelection',
                    controlSettings: {
                        properties: [
                            {
                                bind: 'sheetName',
                                controlType: 'TextBox',
                                displayName: stringResources.ModelName_SheetName,
                                required: true
                            }
                        ],
                        browseSettings: {
                            includedSettingsKeys: ['spreadSheetId'],
                            schemaLabelKey: 'item.properties.title',
                            schemaValueKey: 'item.properties.title'
                        }
                    }
                },
                {
                    bind: 'startCell',
                    controlType: 'TextBox',
                    displayName: stringResources.Dataflow_GoogleSheets_startCell
                },
                {
                    bind: 'endCell',
                    controlType: 'TextBox',
                    displayName: stringResources.Dataflow_GoogleSheets_endCell
                }
            ],
            itemSettings: {
                dataflowType: 'googlesheets',
                dataflowFormat: 'rest',
                dataflowUseInlineProjection: true,
                dataflowConnectTransformationProperties: ['spreadSheetId']
            }
        }
    }
};

export default connector;
